/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavAiSparkleGridItem from 'bundles/composable-page-header/components/grid-items/NavAiSparkleGridItem';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileAccountMenuGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileAccountMenuGridItem';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import MobileSearchBarGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileSearchBarGridItem';
import AccountMenuConfig from 'bundles/composable-page-header/components/mobile-menu-items/AccountMenuConfig';
import LoggedInMobileMenuConfigWithMetaNav from 'bundles/composable-page-header/module-renderers/LoggedInMobileMenuConfigWithMetaNav';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

type Props = {
  showDiscoveryElements?: boolean;
  showSearch?: boolean;
};

const styles = {
  gridItemContainer: css`
    display: flex;
    align-items: center;
  `,
};

const LoggedInConsumerWithMetaNavLinksMobileMainNav = ({ showDiscoveryElements = true, showSearch = true }: Props) => {
  const {
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    isCourseraPlusLearner,
    chosenDegree,
    chosenEnterpriseProgram,
    hasEnrolledPrograms,
    naptimeManagedThirdPartyOrganizations,
    hasCheatingIncidents,
    canViewEducatorAdminLink,
    courseraPlusSubscriptionCycle,
    naptimeChosenOrganization,
    naptimeOrganizationsWithProgramEnrollments,
  } = useConsumerMyPageHeader();

  const isOrgScoped = GrowthDiscoveryEpicClient.preview('orgScopedHome');

  return (
    <MainNavigationWrapper>
      <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
        <Grid item css={styles.gridItemContainer}>
          <MobileMenuIconGridItem
            menuConfig={
              <LoggedInMobileMenuConfigWithMetaNav
                showDiscoveryElements={showDiscoveryElements}
                enrolledDegreePrograms={enrolledDegreePrograms}
                enrolledEnterprisePrograms={enrolledEnterprisePrograms}
                isCourseraPlusLearner={isCourseraPlusLearner}
                chosenDegree={chosenDegree}
                chosenEnterpriseProgram={chosenEnterpriseProgram}
                hasEnrolledPrograms={!!hasEnrolledPrograms}
                naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
                hasCheatingIncidents={hasCheatingIncidents}
                canViewEducatorAdminLink={canViewEducatorAdminLink}
                courseraPlusSubscriptionCycle={courseraPlusSubscriptionCycle}
              />
            }
            homeLogo={<HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />}
          />
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />
        </Grid>
        <Grid item css={styles.gridItemContainer}>
          <NavAiSparkleGridItem />
          <NotificationsLegacyGridItem />
          {showSearch && showDiscoveryElements && <MobileSearchBarGridItem />}
          {isOrgScoped && (
            <MobileAccountMenuGridItem
              isCourseraPlusLearner={!!isCourseraPlusLearner}
              menuConfig={
                <AccountMenuConfig
                  hasEnrolledPrograms={!!hasEnrolledPrograms}
                  naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
                  canViewEducatorAdminLink={canViewEducatorAdminLink}
                  hasCheatingIncidents={hasCheatingIncidents}
                  currentOrganization={naptimeChosenOrganization}
                  currentDegree={chosenDegree}
                  degrees={enrolledDegreePrograms}
                  organizations={naptimeOrganizationsWithProgramEnrollments}
                />
              }
            />
          )}
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedInConsumerWithMetaNavLinksMobileMainNav;
